import {
  type FeedbackOptionCategory,
  OrderListFeedbackContextProvider,
  type UserData,
} from "../OrderDetailsPage/hooks/useSendOrderFeedback/components/OrderListFeedbackContext";
import { OrderListPage } from "./OrderListPage";
import { MultiAccountSearchDataProvider } from "./components/OrderListSearchBox/MultiAccountSelect/MultiAccountSearchDataProvider";

export function create(data: { userData: UserData; orderFeedbackOptions: FeedbackOptionCategory[]; accounts: string; filters: string}) {
  return (
    <OrderListFeedbackContextProvider
      value={{ userData: data.userData, orderFeedbackOptions: data.orderFeedbackOptions }}
    >
      <MultiAccountSearchDataProvider accountsJson={data.accounts}>
        <OrderListPage />
      </MultiAccountSearchDataProvider>
    </OrderListFeedbackContextProvider>
  );
}
